export default __webpack_public_path__ + "f9a42b31fc7f5e6138cecc395e7b9873.png";